import { useCallback, useEffect, useState } from "react";
import ToggleTabs from "../utility/ChartTableToggle";
import GnaMetricsVolumeAnylysis from "./GnaMetricsVolume";
import GnaMetricsCostAnylysis from "./GnaMetricsCost";
import StatisticsAnylysis from "./GnaStatisticMetrics";
import { fetchProcurementSimulationMetricsData } from "../../../../Rest_api/DemoRestApi";
export default function MetricsAnylysis({
  selectedBlock,
  refreshKey,
  setError,
  activeTab,
  setActiveTab,
}: {
  selectedBlock: any[];
  refreshKey: number;
  setError?: any;
  activeTab?: string;
  setActiveTab?: (tab: string) => void;
}) {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any[]>([]);

  const handleFetchData = useCallback(async () => {
    // if (!preSelectedDate || !modSelectedSession) return;

    try {
      setLoading(true);
      const response = await fetchProcurementSimulationMetricsData();
      const res = [response];
      setData(res);
    } catch (error) {
      console.error("Error fetching data", error);
      setError("An error occurred while fetching data.");
    } finally {
      setLoading(false);
    }
  }, [setError]);

  useEffect(() => {
    handleFetchData();
  }, [handleFetchData, refreshKey]);

  return (
    <>
      <div className="load-data flex flex-wrap items-center w-full h-full md:overflow-hidden !p-0">
        <div className=" !bg-[#fff]  w-full !min-h-[100%] overflow-auto">
          {activeTab === "Volume" && (
            <GnaMetricsVolumeAnylysis
              selectedBlock={selectedBlock}
              refreshKey={refreshKey}
              setError={setError}
              loading={loading}
              data={data}
            />
          )}
          {activeTab === "Cost" && (
            <GnaMetricsCostAnylysis
              selectedBlock={selectedBlock}
              refreshKey={refreshKey}
              setError={setError}
              loading={loading}
              data={data}
            />
          )}
          <StatisticsAnylysis
            selectedBlock={selectedBlock}
            refreshKey={refreshKey}
            setError={setError}
            activeTab={activeTab}
            data={data}
            loading={loading}
          />
        </div>
      </div>
    </>
  );
}
